import { FaTrash } from "react-icons/fa";
import { useConfirmationModal } from "../../hooks/useConfirmationModal";
import ConfirmationModal from "../../components/ui/ConfirmationModal";
import { useCart } from "../../hooks/useCart";

interface CartItemProps {
  item: {
    id: string; // تغيير من number إلى string
    name: string;
    price: number | string;
    icon?: string;
    quantity: number;
    subscription?: number;
    service?: number;
    order_id?: number;
    order_items?: {
      subscription?: number;
      service?: number;
    }[];
  };
}

const CartItem = ({ item }: CartItemProps) => {
  const { removeItem } = useCart();
  const {
    show: showRemoveItemModal,
    open: openRemoveItemModal,
    close: closeRemoveItemModal,
  } = useConfirmationModal();

  const handleRemoveItem = () => {
    removeItem(item.id);
    closeRemoveItemModal();
  };

  return (
    <div className='relative border-2 border-red-300 rounded-xl p-4 flex flex-col items-center justify-between text-center space-y-2'>
      <button
        className='absolute top-2 left-2 text-gray-700 hover:text-red-700 transition-colors duration-300'
        onClick={openRemoveItemModal}
        type='button'
      >
        <FaTrash className='text-xl' />
      </button>

      {item.icon ? (
        <img
          src={item.icon}
          alt={item.name}
          className='w-14 h-14 mb-2 object-contain'
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = "none";
          }}
        />
      ) : (
        <span className='text-4xl mb-2'>🧾</span>
      )}

      <div className='flex flex-col space-y-1'>
        <span className='text-base font-bold'>{item.name}</span>
        <span className='text-red-600 text-lg'>
          {Number(item.price).toFixed(2)} ريال
        </span>
      </div>

      <ConfirmationModal
        show={showRemoveItemModal}
        title='تأكيد الحذف'
        message='هل متأكد من حذف هذا المنتج من السلة؟'
        onConfirm={handleRemoveItem}
        onCancel={closeRemoveItemModal}
      />
    </div>
  );
};

export default CartItem;
